import './../../../alcoholhulp.be/js/src/app';